/**
 * Campaign-related data models generated from the Mentoring Fusion Campaigns API.
 * Keeping snake_case keys to match the API contract.
 */

// Enum for campaign mode
export enum CampaignMode {
  IN_PERSON = "IN_PERSON",
  VIRTUAL = "VIRTUAL",
  HYBRID = "HYBRID"
}

// Enum for campaign status
export enum CampaignStatus {
  PREP = "PREP",
  MATCHING = "MATCHING",
  RUNNING = "RUNNING",
  CLOSED = "CLOSED",
}

/**
 * Data transfer object for updating campaigns with all fields optional
 * Based on CampaignUpdateDTO from the API spec
 */
export interface CampaignUpdateDTO {
  campaign_name?: string | null;
  focus?: string | null;
  goals?: string | null;
  purpose?: string | null;
  applications_open?: string | null;         // date (YYYY-MM-DD)
  applications_close?: string | null;        // date
  match_notification_date?: string | null;   // date
  matches_finalized?: string | null;         // date
  kickoff?: string | null;                   // date
  closing?: string | null;                   // date
  feedback_deadline?: string | null;         // date
  active?: boolean | null;
}

/** Payload for creating a campaign */
export interface CampaignCreate extends CampaignUpdateDTO {
  organization_id: string;
}

/** Payload for updating a campaign (all fields optional) */
export interface CampaignUpdate extends CampaignUpdateDTO {
  organization_id?: string;
  campaign_status?: CampaignStatus;
}

/** 
 * Full Campaign model returned by API 
 * Based on CampaignResponseDTO from the API spec
 */
export interface Campaign {
  id: string;
  organization_id: string;
  campaign_name?: string | null;
  campaign_status: CampaignStatus;
  focus?: string | null;
  goals?: string | null;
  purpose?: string | null;
  applications_open?: string | null;         // date (YYYY-MM-DD)
  applications_close?: string | null;        // date
  match_notification_date?: string | null;   // date
  matches_finalized?: string | null;         // date
  kickoff?: string | null;                   // date
  closing?: string | null;                   // date
  feedback_deadline?: string | null;         // date
  active: boolean;
  campaign_code: string;
}

/** 
 * Slimmed down campaign info list item 
 * Based on CampaignInfo from the API spec
 */
export interface CampaignInfo {
  id: string;
  organization_id: string;
  campaign_name: string;
  campaign_status: CampaignStatus;
}

export interface ApiError {
  detail: string;
}

/** Request payload for generating campaign dates */
export interface DateRequest {
  kickoff: string; // YYYY-MM-DD
  closing: string; // YYYY-MM-DD
}

/** Generated campaign dates returned by the AI service */
export interface CampaignDates {
  kickoff: string | null;
  closing: string | null;
  applications_open: string | null;
  applications_close: string | null;
  match_notification_date: string | null;
  matches_finalized: string | null;
  feedback_start: string | null;
  feedback_deadline: string | null;
  total_duration: number | null;
  applications_duration: number | null;
  applications_open_duration: number | null;
  applications_close_duration: number | null;
  match_notification_duration: number | null;
  matches_finalized_duration: number | null;
  feedback_start_duration: number | null;
  feedback_deadline_duration: number | null;
}
